export default "__VITE_ASSET__BlUr6_WM__"